import React, { useEffect, useState, useRef  } from "react"
import axios from "axios"
import { currency, MainWrap } from "../../utilities/Shared"
import { useSearchParams } from "react-router-dom"


const SalesReport = () => {
    const [searchParams] = useSearchParams()
const didInitFromUrl = useRef(false)
  const [salesReps, setSalesReps] = useState([])
  const [salesRep, setSalesRep] = useState("")

  const [timeFrame, setTimeFrame] = useState("today")
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")

  const [header, setHeader] = useState("")
  const [alljobs, setAlljobs] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)


  console.log(searchParams.r)
  /* ---------------- LOAD SALES REPS ---------------- */
useEffect(() => {
  if (!salesReps.length) return
  if (didInitFromUrl.current) return

  const repFromUrl = searchParams.get("r")
  if (repFromUrl) {
    setSalesRep(String(repFromUrl))
  }

  didInitFromUrl.current = true
}, [salesReps, searchParams])





  useEffect(() => {
    axios.get("https://highgroundapi.herokuapp.com/employee/sales").then(res => {
        console.log(res.data)
      setSalesReps(res.data)
    })
  }, [])

  /* ---------------- AUTO SEARCH ---------------- */

  useEffect(() => {
    if (timeFrame !== "spec") {
      fetchReport()
    }
  }, [salesRep, timeFrame])

  /* ---------------- FETCH REPORT ---------------- */

  const fetchReport = async () => {
  setLoading(true)

   const params= {
        r: salesRep || 0,
        s: timeFrame,
        st: timeFrame === "spec" ? startDate : undefined,
        se: timeFrame === "spec" ? endDate : undefined
      }

  console.log(params)
  try {
    const res = await axios.post("https://highgroundapi.herokuapp.com/sales/details", params)
console.log(res.data)
    setHeader(res.data.header)
    setAlljobs(res.data)
    setTotal(res.data.total)
  } catch (err) {
    console.error("Failed to load sales report", err)
  } finally {
    setLoading(false)
  }
}


  /* ---------------- HANDLERS ---------------- */

  const handleTimeFrameChange = e => {
    const value = e.target.value
    setTimeFrame(value)

    if (value !== "spec") {
      setStartDate("")
      setEndDate("")
    }
  }

  const handleSpecificSearch = () => {
    if (!startDate || !endDate) return
    fetchReport()
  }

  /* ---------------- RENDER ---------------- */
console.log(alljobs)
  return (
 <MainWrap
  
>

      <div style={{ fontSize: "18pt", textAlign: "center", marginBottom:20 }}>
        {header}
      </div>

      {/* TOP CONTROLS */}
      <div style={{ display: "flex", gap: 20, marginBottom: 20, flexWrap: "wrap", maxWidth: "100%" }}>
        {/* SALES REP */}
        <div style={{ flex: 1 }}>
          Sales Rep<br />
          <select
            value={salesRep}
            onChange={e => setSalesRep(e.target.value)}
            style={{ width: "80%" }}
          >
            <option value="">All</option>
            {salesReps.map(rep => (
           <option key={rep.empId} value={String(rep.empId)}>

                {rep.firstName} {rep.lastName.substr(0,1)}
              </option>
            ))}
          </select>
        </div>

        {/* TIME FRAME */}
        <div style={{ flex: 1 }}>
          Time Frame<br />
          <select value={timeFrame} onChange={handleTimeFrameChange}>
            <option value="today">Today</option>
            <option value="tw">This Week</option>
            <option value="lw">Last Week</option>
            <option value="tm">This Month</option>
            <option value="qtd">Quarter To Date</option>
            <option value="ytd">Year To Date</option>
            <option value="spec">Specific</option>
          </select>
        </div>

        {/* START DATE */}
        {timeFrame === "spec" && (
          <>
            <div style={{ flex: 1 }}>
              Start<br />
              <input
                type="date"
                value={startDate}
                onChange={e => setStartDate(e.target.value)}
                style={{ width: "80%" }}
              />
            </div>

            <div style={{ flex: 1 }}>
              End<br />
              <input
                type="date"
                value={endDate}
                onChange={e => setEndDate(e.target.value)}
                style={{ width: "80%" }}
              />
            </div>

            <div style={{ flex: 1, alignSelf: "flex-end" }}>
              <button onClick={handleSpecificSearch}>Search</button>
            </div>
          </>
        )}
      </div>

      {/* SUMMARY */}
      <div style={{ display: "flex", marginBottom: 10 }}>
        <div style={{ flex: 1, fontSize: "12pt", fontWeight: "bold" }}>
          {alljobs.jobs?.length} Jobs
        </div>
        <div
          style={{
            flex: 1,
            textAlign: "right",
            fontSize: "12pt",
            fontWeight: "bold"
          }}
        >
          {currency(total)}
        </div>
      </div>

      {/* TABLE */}
      <table width="100%" style={{ borderCollapse: "collapse" }}>
        <thead style={{ background: "#8398AB" }}>
          <tr>
            <th>Customer</th>
            <th>Job Title</th>
            <th>Job #</th>
            <th>Enter Date</th>
            <th>Quantity</th>
            <th style={{ textAlign: "right" }}>Sale</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <td colSpan="6" style={{ textAlign: "center" }}>
                Loading…
              </td>
            </tr>
          )}

          {!loading &&
            alljobs?.jobs?.map(job => (
              <tr key={job.id} className="normalrow" >
                <td style={{padding:"6px 0px"}}>{job.customer}</td>
                <td>{job.jobname}</td>
                <td>{job.job}</td>
                <td>
                  {new Date(job.createdAt).toLocaleDateString()}
                </td>
                <td style={{ textAlign: "center" }}>{job.quantity}</td>
                <td style={{ textAlign: "right" }}>
                  {currency(job.total)}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </MainWrap>
  )
}

export default SalesReport
